import React from 'react';

import { flagStyles } from '../settings';

const SvgVC = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5592px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgVC;
